module.exports = __webpack_public_path__ + "img/cloud-bg.877f87c2.png";